import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { Simplify } from '../../../../prismicio-types';
import { WhiteCheckmarkIcon } from '@/assets/icons/PartnerPagesIcons';
import styles from './AchieveImageContent.module.scss';

interface Props {
  data: Simplify<Content.PartnerHeroSliceDefaultPrimary>;
}

const AchieveImageContent = ({ data }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.leftBlock}>
        <PrismicNextImage
          field={data.partnerlogo}
          className={styles.partnerlogo}
        />
        <div className={styles.infoCard}>
          <div className={styles.infoCardHead}>
            <span className={styles.infoCardTitle}>{data.infotitle}</span>
            <div className={styles.iconWrapper}>
              <WhiteCheckmarkIcon className={styles.icon} />
            </div>
          </div>
          <p className={styles.infoCardValue}>{data.infovalue}</p>
        </div>
      </div>
      <PrismicNextImage field={data.personimg} className={styles.personImg} />
    </div>
  );
};

export default AchieveImageContent;
